import { Flex, FlexProps } from "@chakra-ui/layout"
import { useTranslation } from "react-i18next"

const LiveIcon = (props: FlexProps) => {
  const { t } = useTranslation()

  return (
    <Flex {...props}>
      <Flex
        width="40px"
        height="24px"
        fontSize="12px"
        fontWeight="medium"
        borderColor="white"
        borderWidth="1px"
        rounded="4px"
        justifyContent="center"
        alignItems="center"
        color="white"
        background="black"
      >
        {t("LIVE")}
      </Flex>
    </Flex>
  )
}

export default LiveIcon
